import { galleryDaysBeforeOpening, mediaOriginLabel, mediaOriginShortLabel } from '@mustauto/utils';
import { cn } from './cn';

/**
 * Selo "Galeria" sobre a miniatura de uma mídia da OS que veio da galeria do
 * aparelho (`os_media.source = 'gallery'`) — painel do gestor e backoffice.
 * A câmera do app (e a mídia antiga, sem origem) não leva selo nenhum.
 *
 * Fica sobre a foto, com fundo escuro próprio, para valer nos dois temas e em
 * qualquer foto. Em âmbar quando a foto é de bem antes da abertura da OS: aí
 * ela não prova como o carro chegou. O texto inteiro ("Da galeria · tirada em
 * 12/10/2026") vai no `title` — e o pai pode repeti-lo na legenda.
 *
 * O pai precisa ser `relative`. Canto INFERIOR esquerdo: os de cima já são
 * do botão de baixar (esquerdo, no hover) e do selo "Interno" (direito) no
 * painel. Onde o rodapé tem outra faixa (legenda da etapa), suba com
 * `className`.
 */
export function MediaOriginTag({
  source,
  takenAt,
  openedAt,
  className,
}: {
  source: string | null | undefined;
  takenAt: string | number | null | undefined;
  /** Criação da OS: com ela, o selo diz quando a foto é de dias antes. */
  openedAt?: string | number | null;
  className?: string;
}) {
  const short = mediaOriginShortLabel(source, takenAt, openedAt);
  const full = mediaOriginLabel(source, takenAt, openedAt);
  if (!short || !full) return null;
  const stale = galleryDaysBeforeOpening(takenAt, openedAt) != null;
  return (
    <span
      title={full}
      aria-label={full}
      className={cn(
        'pointer-events-none absolute bottom-1 left-1 max-w-[calc(100%-0.5rem)] truncate rounded px-1.5 py-0.5 text-[10px] font-medium text-white',
        stale ? 'bg-amber-600/90' : 'bg-black/65',
        className,
      )}
    >
      {short}
    </span>
  );
}
